import {defineField} from 'sanity'
export default defineField({
  title: 'Button Type',
  type: 'string',
  name: 'buttonType',
  description: 'leave empty for default',
  options: {
    list: [
      {title: 'Primary', value: 'primary'},
      {title: 'Accent', value: 'accent'},
      {title: 'Secondary', value: 'secondary'},
      {title: 'Text', value: 'text'},
      {title: 'Link', value: 'link'},

      {title: 'Primary inverted', value: 'primary_inverted'},
      {title: 'Accent inverted', value: 'accent_inverted'},
      {title: 'Secondary inverted', value: 'secondary_inverted'},
      {title: 'Text inverted', value: 'text_inverted'},
    ],
  },
})
